export var CONSTRAINED_PAGE_MAX_WIDTH = '1000px';
export var HEADER_CONTENT_HEIGHT = '60px';